
import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChange} from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { BaseError } from "../../../../base-error";

@Component({
  selector: "button-determinant",
  templateUrl: "./button-determinant.component.html",
  styles: [],
  providers: [
    ToastrService,
  ],
})
export class ButtonDeterminantComponent extends BaseError implements OnInit, OnChanges {
  @Input() public serviceId: string;
  @Input() public buttonEventName: string = "click";
  @Input() public buttonKey: string;
  @Output() public buttonEventNameResponse = new EventEmitter();
  @Output() public buttonKeyResponse = new EventEmitter();

  public buttonEvents: any[] = [
    { key: "click", name: "Click" }
  ];

  constructor(
    public toastr: ToastrService,
  ) {
    super(toastr);
  }

  public ngOnInit() {
    // Button field is selected in parent component's "Select field"
    // No event selection needed for buttons - just the field selection is enough
  }

  public ngOnChanges(changes: { [propName: string]: SimpleChange }) {
    if (changes.buttonKey?.currentValue) {
      this.buttonKey = changes.buttonKey.currentValue;
    }
  }

  public buttonEventNameChanged() {
    this.buttonEventNameResponse.emit(this.buttonEventName);
  }
}
